import { ActionsForm } from '@/components/ui/modals/DetailCandidacyModal/types';

import { MainForm, DeclineForm, TalkForm } from './components';

export const forms = {
  [ActionsForm.main]: MainForm,
  [ActionsForm.decline]: DeclineForm,
  [ActionsForm.talk]: TalkForm,
};
